import { mapGetters } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

import { UPDATE_PROFILE, GET_USER } from "../gql/AuthQueries";

export default {
  name: "personalize",

  data() {
    return {
      firstName: "",
      lastName: "",
      submitLoading: false,
      skipGetUser: true
    };
  },

  validations() {
    let params = {
      firstName: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(64)
      },
      lastName: {
        minLength: minLength(1),
        maxLength: maxLength(64)
      }
    };

    return params;
  },

  props: {
    isBuyerRegistration: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    })
  },

  mounted: function() {},

  apollo: {
    getUser: {
      query: GET_USER,
      skip() {
        return this.skipGetUser;
      },

      result({ data: { getUser } }) {
        this.$store.dispatch("initUser", getUser);
        this.$router.push({ name: "home" });
        this.skipGetUser = true;
      }
    }
  },

  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitLoading = true;

        this.$apollo
          .mutate({
            mutation: UPDATE_PROFILE,
            variables: {
              firstName: this.firstName,
              lastName: this.lastName
            }
          })
          .then(({ data: { updateProfile } }) => {
            this.submitLoading = false;

            if (this.isBuyerRegistration) {
              // this.$emit("showFinishLoader");

              // for redirect HomeOwners after signUp
              this.$store.commit("setIsSignUp", true);
              this.$store.dispatch("initUser", updateProfile.user);
              this.clearSignUpData();
              // setTimeout(() => {
              //   // Redirect on Home page in Watch
              // }, 3100);
            } else {
              this.$store.dispatch("initUser", updateProfile.user);
              this.$router.replace({
                name: "properties"
              });
              // Redirect on Home page in Watch
            }
          })
          .catch(mutationError => {
            const errors = mutationError.graphQLErrors;

            for (let error in errors) {
              this.$toasted.error(errors[error].message);
            }

            this.submitLoading = false;
          });
      }
    },

    clearSignUpData(next = null) {
      localStorage.removeItem("signupEmail");
      localStorage.removeItem("searchParams");
      localStorage.removeItem("signupAgentInfo");

      if (next) {
        if (localStorage.getItem("AUTH_TOKEN") && !this.$store.state.user.id) {
          this.skipGetUser = false;
          next(false);
        } else {
          next();
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.clearSignUpData(next);
    // localStorage.removeItem("signupEmail");
    // localStorage.removeItem("searchParams");
    // localStorage.removeItem("signupAgentInfo");
    // if (localStorage.getItem("AUTH_TOKEN") && !this.$store.state.user.id) {
    //   this.skipGetUser = false;
    //   next(false);
    // } else {
    //   next();
    // }
  }
};
